"use strict";exports.STATUS={GENERAL:"general",SUCCESS:"success",INFO:"info",WARNING:"warning",ERROR:"error",HELP:"help"};
